import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'react-apollo';

import {query} from 'flows/home2';

import Spinner from 'components/Spinner';

import Home from './component';

export const HomeContainer = ({data: {loading, userinfo}}) => {
  if (loading) {
    return (
      <Spinner />
    );
  }

  return (
    <Home invites={userinfo.invites} />
  );
};

HomeContainer.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    userinfo: PropTypes.object,
  }).isRequired,
};

const mapPropsToOptions = () => ({
  fetchPolicy: 'network-only'
});

export default graphql(query, {
  options: mapPropsToOptions
})(HomeContainer);



// WEBPACK FOOTER //
// ./web/flows/home/index.js